<template>
  <div class="outpage" v-loading.fullscreen.lock="loading">
    <div class="w100 sta1 flex-cc">
      <div class="flex-cc">
        <img class="mlogo1" src="../assets/logo.png" alt="">
        <div class="mlogo2">
          <div class="mlp1">网络空间内生安全知识平台</div>
          <div class="mlp2">KNOWLEDGE SYSTEM OF CYBERSPACE ENDOGENOUS SAFETY&SECURITY</div>
        </div>
      </div>
      <div class="sta3" style="min-width: 190px;">{{ titleinfo.name }}</div>
    </div>
    <div class="w100 stamiddle" ref="scrollContainer">
      <div v-show="detailnum == 1" class="stam1">
        <div class="flex-cc mt30 mt20">
          <div v-for="(item,index) in dinglist" class="flex-hl fll1 mt10"><span @click="changelei(item)" class="fll3"
                                                                                :class="[item.id == dingid?'leihot':'']">{{
              item.name
            }}</span><span
              v-if="index != (dinglist.length-1)" class="fll2">|</span></div>
        </div>
        <div class="w100">
          <el-form :inline="true" :model="sform" class="demo-form-inline sformin mt20">
            <el-form-item label="" class="w200 wnew200">
              <el-input v-model="sform.input" placeholder="搜索内容"></el-input>
            </el-form-item>
            <el-form-item label="上传时间" class="w270 wnew270">
              <el-date-picker
                  v-model="sform.time"
                  popper-append-to-body
                  type="daterange"
                  ref="datePicker"
                  :placement.sync="pickerPlacement"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="发布人" class="w200 wnew200">
              <el-input v-model="sform.user" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item>
              <div class="flex-hl">
                <div @click="subsear" class="searbtn1 cur"><i class="el-icon-search"></i></div>
                <div @click="resetsear" class="searbtn2 cur">重置</div>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div class="forum2 mt10">
          <!--          <el-tooltip class="w100 overflow" effect="dark" :content="scope.row.date" placement="top-start">-->
          <!--            <el-button class="noborder w100">-->
          <!--              {{ scope.row.date }}scope.row.datescope.row.datescope.row.datescope.row.datescope.row.datescope.row.date-->
          <!--            </el-button>-->
          <!--          </el-tooltip>-->
          <div class="w100">
            <div class="flex-hlc mbom20 hpx180" v-for="(item,index) in datalist" @click="newtodetail(item)">
              <div class="wlisti1">
                <img :src="item.img?item.img:require('../assets/img/zanwu.png')" alt="">
              </div>
              <div class=" flex-hl listz1">
                <div class="w100 mbom5">
                  <el-tooltip class="w100 overflow" effect="dark" :content="item.title" placement="top-start">
                    <el-button class="noborder w100">
                      {{ item.title }}
                    </el-button>
                  </el-tooltip>
                </div>
                <div class="listz2 flex-hlc mbom5">
                  <div>{{ item.gmtCreate }}</div>
                  <div class="wms1">|</div>
                  <div>来源：{{ item.source }}</div>
                  <div class="wms1">|</div>
                  <div class="flex-cc">
                    <img class="wxim1" src="../assets/img/liulan.png" alt="">
                    <span>{{ item.views }}</span>
                  </div>
                </div>
                <div class="listz3 over3 w100 mbom5">{{ item.content }}</div>
              </div>
            </div>
          </div>

          <div class="w100 mt20 flex-cc">
            <el-pagination
                v-if="datalist.length > 0"
                background
                layout="prev, pager, next"
                :current-page.sync="pageObj.currentPage"
                :page-size="pageObj.pageSize"
                :total="pageObj.total"
                @current-change="pageChange">
            </el-pagination>
          </div>
        </div>
      </div>
      <div v-show="detailnum == 2" class="stam1">
        <div class="w100 sta6"><span class="cur" @click="tohome">首页></span><span v-if="parinfo" class="cur"
                                                                                   @click="backyuan">{{
            titleinfo.name
          }}></span><span>详情</span>
        </div>
        <div class="w100 newwai-content">
          <div class="sta4 mt20 w100" style="min-height: 58vh !important;">
            <el-tooltip class="w100 overflow" effect="dark" :content="articleinfo.title" placement="bottom">
              <el-button class="titleborder w100">
                {{ articleinfo.title }}
              </el-button>
            </el-tooltip>
            <!--            <div class="wenxiang over1">{{ articleinfo.title }}</div>-->
            <div class="wenxiang2 flex-cc">
              <div>{{ articleinfo.user }}</div>
              <div class="wms1">|</div>
              <div>{{ articleinfo.gmtCreate }}</div>
              <div class="wms1">|</div>
              <div>来源：{{ articleinfo.source }}</div>
              <div class="wms1">|</div>
              <div class="flex-cc">
                <img class="wxim1" src="../assets/img/liulan.png" alt="">
                <span>{{ articleinfo.views }}</span>
              </div>
              <!--            <div class="wms1">|</div>-->
              <!--            <div class="flex-cc">-->
              <!--              <img class="wxim2" src="../assets/img/huifu.png" alt="">-->
              <!--              <span>5</span>-->
              <!--            </div>-->
              <div class="flex-cc fenx1" :class="articleinfo.share?'':'tishi'" @click="openfx">
                <img class="fenx2" src="../assets/img/fenxiang.png" alt="">
                <span>分享</span>
              </div>
            </div>
            <div class="w100" style="color: white !important;" v-html="articleinfo.content">

            </div>
          </div>
        </div>
        <div class="w100 ifaout" v-for="(item,idx) in pdflist">
          <div class="pdf-name flex-hls">
            <span class="pnammeov">{{ item.name }}</span>
            <img class="clpdf" @click="lookpdf(item.url)" src="../assets/img/sceen.png" alt="">
          </div>
          <iframe
              :id="'myiframe'+idx"
              :src="item.url"
              frameborder="0"
              style="height: 90vh;"
              width="100%"
          ></iframe>
        </div>
        <div class="sta5 w100 mt20">
          <div><span class="colorql">附件</span><span
              class="ml5">{{ articleinfo && articleinfo.attachmentList ? articleinfo.attachmentList.length : 0 }}</span>
          </div>
          <div class="sta7" v-if="articleinfo && articleinfo.attachmentList">
            <div class="flex-hlc w100 mbom10 cur" v-for="(item,idx) in articleinfo.attachmentList">
              <div class="flex-hlc flex-box newkuanlo" @click="openfile(item)">
                <img class="sta8" src="../assets/img/fujian.png" alt="">
                <span class="sta9 flex-1 over1">
                {{ item.name }}
              </span>
              </div>
              <img v-if="articleinfo.download" @click="downfile(item)" class="downimg" src="../assets/img/down.png"
                   alt="">
            </div>
          </div>
        </div>
        <div style="width: 100%;height: 40px;"></div>
      </div>
      <div class="bottomd flex-cc">
        <span>Copyright ◎ 2026 紫金山实验室,All Rights Reserved.</span>
        <span class="shus"></span>
        <img src="../assets/guohui.png" class="jinghui" alt="">
        <span>苏CP备14016373号-4</span>
      </div>
    </div>
    <div class="dingping" v-if="showpdf">
      <img class="closepdf" @click="showpdf = false" src="../assets/img/close.png" alt="">
      <iframe
          :src="pdfurl"
          frameborder="0"
          width="100%"
          height="100%"
      ></iframe>
    </div>
    <el-dialog
        title=""
        class="tanpassk"
        append-to-body
        :close-on-click-modal="false"
        :show-close="false"
        :visible.sync="showMask"
        width="60%">
      <div class="fenxd1 flex-hl">
        <div class="choosed1">
          <el-input
              placeholder="搜索"
              v-model="filterText"
              clearable>
          </el-input>
          <div class="w100 mt10 mbom10">
            <el-checkbox
                v-model="checkAll"
                :indeterminate="isIndeterminate"
                @change="handleCheckAllChange">
              <span class="quanx">全选</span>
            </el-checkbox>
          </div>
          <div class="choosed6">
            <el-tree
                :data="datatree"
                show-checkbox
                node-key="id"
                ref="tree"
                :filter-node-method="filterNode"
                default-expand-all
                @check="handleCheck"
                :props="topprops"
                :expand-on-click-node="false"
                :check-on-click-node="true">
      <span class="custom-tree-node flex-hlc" slot-scope="{ node, data }">
<!--        <span class="flex-hlc">-->
          <img v-if="data.userList" class="buimg" src="../assets/img/bum.png" alt="">
          <span class="butext">{{ node.label }}</span>
        <!--        </span>-->
      </span>
            </el-tree>
          </div>

        </div>
        <div class="choosed2">
          <div class="choosep2">已选择({{ checktreelist.length }}/{{ checkzong }})</div>
          <div class="w100 choosewai">
            <div class="choosep1 flex-cc flex-box" v-for="(item,index) in checktreelist">
              <img class="choosed4" src="../assets/img/ren.png" alt="">
              <div class="choosed3 flex-1 over1">{{ item.name }}</div>
              <img @click="delpeople(item,index)" class="choosed5" src="../assets/img/x.png" alt="">
            </div>
          </div>
          <div class="choosed7 w100 flex-hr">
            <div @click="noreplay" class="quxiaohui mr20">取消</div>
            <div @click="subreplay()" class="querenlan">分享</div>
          </div>
        </div>


      </div>
    </el-dialog>
  </div>
</template>

<script>
import Editor from '@/components/Richtext';

export default {
  name: 'statistics',
  components: {
    Editor
  },
  props: {
    pushnum: [String, Object, Array, Number],
  },
  data() {
    return {
      content: '撒撒打发撒打发手打阿发送达啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊阿发法撒旦的点点滴滴滴答滴答',
      contenthui: '',
      filterText: '',
      titlew: '中外专家为构建网络安全免疫系统建言献策',
      cursorPosition: 0,//评论当前光标位置
      cursorPositionhui: 0,//回复当前光标位置
      isComposing: false, // 中文输入法状态标记
      showPicker: false,
      showMask: false,
      showpdf: false,
      showPickerhui: false,
      replaylook: false,
      pdfurl: '',
      pdfname: '',
      pickerPlacement: 'bottom-start',
      datalist: [],
      pageObj: {
        pageSize: 10,
        total: 0,
        currentPage: 1
      },
      sform: {
        input: '',
        time: '',
        user: '',
      },
      checkAll: false,
      checkzong: 0,//总数量
      checkxuan: 0,//选中的数量
      isIndeterminate: false,
      checktreelist: [],//选中的树的二级
      datatree: [],
      topprops: {
        label: 'name',
        children: 'userList',
        value: 'id',
        // emitPath:false
      },
      tableData: [{
        date: '2016-05-02',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1518 弄'
      }, {
        date: '2016-05-04',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1517 弄'
      }, {
        date: '2016-05-01',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1519 弄'
      }, {
        date: '2016-05-03',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1516 弄'
      }],
      detailnum: 1,//1是列表2是详情
      loading: false,
      articleinfo: '',
      pdflist: [],//新版pdf列表
      // 保存原始滚动位置
      scrollTop: 0,
      titlebu: '',
      richText: '',
      parinfo: true,//是否没有搜索条件 true是没有
      queryinfo: '',//传过来的值
      dinglist: [],//顶部小分类列表
      neilist: [],//顶部外层分类列表
      dingid: '',//选中的id=categoryId	分类id
      titleinfo: '',
      userinfo: JSON.parse(localStorage.getItem('muiuserinfo') || '{}')?.userInfo || null,
    }
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
    pushnum(newVal) {
      // console.log('konwledge接收参数',this.$route.query)
      // this.getdata();
      if (this.$route.query.parentid) {//修改需求-选择了文件类型进来的获取分类和回显，没选择的直接是结果
        this.getneilist();//获取大分类列表1
        this.parinfo = true;
      } else {
        this.getdata();
        this.parinfo = false;
      }
      this.detailnum = 1;
      this.$refs.scrollContainer.scrollTop = 0;
    },
    // 监听遮罩层显示/隐藏，控制滚动锁定
    showpdf(newVal) {
      if (newVal) {
        // 显示遮罩时，禁止背景滚动
        this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop
        document.body.style.position = 'fixed'
        document.body.style.top = `-${this.scrollTop}px`
        document.body.style.width = '100%'
      } else {
        // 隐藏遮罩时，恢复滚动
        document.body.style.position = ''
        document.body.style.top = ''
        // 恢复到原来的滚动位置
        window.scrollTo(0, this.scrollTop)
      }
    },
  },
  // 11
  mounted() {
    console.log('konwledge接收参数', this.$route.query)
    this.showpdf = false;
    this.pdflist = [];
    this.queryinfo = this.$route.query;
    if (this.$route.query.time && this.$route.query.time.length > 0) {//如果有时间转换一下格式
      this.queryinfo.time = JSON.parse(this.$route.query.time);
    }
    if (this.$route.query.parentid) {//修改需求-选择了文件类型进来的获取分类和回显，没选择的直接是搜索结果
      this.getneilist();//获取大分类列表1
      this.parinfo = true;
    } else {
      if (this.queryinfo.time) {
        this.sform.time = this.queryinfo.time;
      }
      this.sform.input = this.queryinfo.input;
      this.sform.user = this.queryinfo.user;
      this.getdata();
      this.parinfo = false;
    }
    this.getuserlist();//获取分享人的树
    if (this.$route.query.artiid) {//如果有文章id进来，那就跳转到文章详情
      this.todetail({id: this.$route.query.artiid});
    }
  },
  // 22
  methods: {

    lookpdf(val) {
      console.log(val)
      this.pdfurl = val;
      this.showpdf = true;
    },
    tohome() {
      this.$router.push({
        path: '/',
      })
    },
    backyuan() {
      this.detailnum = 1;
      this.showpdf = false;
      this.pdflist = [];
      this.articleinfo = '';
      this.$router.push({
        path: '/knowledge',
        query: {
          // 只保留非 'param1' 的查询参数
          ...this.$route.query,
          artiid: null // 这里通过设置为 null 来“删除”这个参数
        }
      }).then(() => {
        // 删除操作后的处理逻辑
      });
    },
    getuserlist() {
      if (!this.userinfo) {
        return false
      }
      let data = {}
      this.$http({
        url: 'user/tree',
        method: 'post',
        data: this.$form(data)
      }).then((res) => {
        this.datatree = res.data.deptList;
        this.checkzong = res.data.total;
        this.loading = false;
      }).catch(err => {
        this.loading = false;
      })
    },
    resetsear() {
      this.sform = Object.assign(this.sform, this.$options.data().sform);
      this.datalist = [];
      this.pageObj = {
        pageSize: 10,
        total: 0,
        currentPage: 1
      }
      this.getdata();
    },
    subsear() {
      this.datalist = [];
      this.pageObj = {
        pageSize: 10,
        total: 0,
        currentPage: 1
      }
      this.getdata(1);
    },
    getneilist() {
      let data = {}
      // 未登录状态下只有登录和首页可以点击
      if (!this.userinfo) {
        data.auth = 0
      }else{
        data.auth = 1
      }
      this.$http({
        url: 'category/tree',
        method: 'post',
        data: this.$form(data)
      }).then((res) => {
        let neilist = JSON.parse(JSON.stringify(res.data));
        if (neilist) {
          neilist.forEach((item, index) => {
            if (!item.children) {
              item.disabled = true;
            }
          })
          this.neilist = neilist;
        }
        this.judgedata();//判断选中状态+回显2
        this.loading = false;
      }).catch(err => {
        this.loading = false;
      })
    },
    judgedata() {
      if (this.queryinfo.parentid) {//是一定会存在的,知识动态下面的一级分裂
        let data = this.neilist.find(item => {
          return item.id == this.queryinfo.parentid
        });
        this.titleinfo = data;
        this.getlist();//获取顶部小分类列表3
      }
      if (this.queryinfo.id) {//选中状态
        this.dingid = this.queryinfo.id;
      }
      if (this.queryinfo.time) {
        this.sform.time = this.queryinfo.time;
      }
      this.sform.input = this.queryinfo.input;
      this.sform.user = this.queryinfo.user;
    },
    //获取顶部小分类列表
    getlist() {
      let data = {
        pid: this.queryinfo.parentid,
        // auth: 1
      }
      if (!this.userinfo) {
        data.auth = 0
      }else{
        data.auth = 1
      }
      this.$http({
        url: 'category/list',
        method: 'post',
        data: this.$form(data)
      }).then((res) => {
        this.dinglist = res.data;
        if (!res.data || res.data.length == 0) {
          return
        } else {
          if (!this.queryinfo.id) {
            this.dingid = res.data ? res.data[0].id : '';//如果没有id用第一个当id
          }
          this.getdata();//获取分页数据4
        }

        this.loading = false;
      }).catch(err => {
        this.loading = false;
      })
    },
    // 获取分页数据
    getdata(val) {
      console.log('meiozu 9999999999')
      // if (!this.dingid && Number(localStorage.getItem('search')) != 1) {
      //   return false;
      // }
      // console.log('Number(localStorage.getItem(\'search\'))',Number(localStorage.getItem('search')))
      let data = JSON.parse(JSON.stringify(this.sform));
      data.pageNumber = this.pageObj.currentPage;
      data.pageSize = this.pageObj.pageSize;
      data.categoryId = this.dingid ? this.dingid : '';
      data.search = Number(localStorage.getItem('search')) || val ? 1 : 0;
      // data.time = data.time ? data.time.join('~') : '';
      if(data.time.length == 2){
        data.time=this.$timeDay(data.time[0])+'~'+this.$timeDay(data.time[1])
      }
      console.log('data',data)
      this.$http({
        url: "article/page",
        method: "POST",
        data: this.$form(data)
      }).then(res => {
        localStorage.removeItem('search');
        this.pageObj.total = res.data.total;
        this.datalist = res.data.records;
      });
    },
    delpeople(val, idx) {
      // console.log('this.checktreelist.indexOf(val.id)', this.checktreelist.indexOf(val.id))
      this.checktreelist.splice(idx, 1);
      this.$refs.tree.setCheckedNodes(this.checktreelist);
      this.handleCheck();
    },
    // 全选
    handleCheckAllChange(val) {
      this.$refs.tree.setCheckedNodes(val ? this.datatree : []);
      this.handleCheck()
    },
    // 选中的值-判断全选全不选
    handleCheck() {
      const checkedCount = this.$refs.tree.getCheckedNodes().length;//树的总长度
      const totalCount = this.countNodes(this.datatree)//选中的长度
      this.checkAll = checkedCount === totalCount;
      this.isIndeterminate = checkedCount > 0 && checkedCount < totalCount;
      // console.log('this.$refs.tree', this.$refs.tree.getCheckedNodes(), checkedCount, totalCount);
      this.checktreelist = this.$refs.tree.getCheckedNodes().filter(item => !item.userList);
      // console.log('checktreelist', this.checktreelist)
    },
    countNodes(data) {
      return data.reduce((total, node) => {
        return total + 1 + (node.userList ? this.countNodes(node.userList) : 0)
      }, 0)
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    openfx() {
      if (this.articleinfo.share) {
        this.checktreelist = [];
        this.showMask = true;
        this.checkAll = false;
        this.$nextTick(() => {
          this.$refs.tree.setCheckedNodes([]);
        })
      }
    },
    downfile(item) {
      // 使用axios下载文件，自动携带token
      this.$http({
        url: 'article/download',
        method: 'GET',
        params: {
          articleId: this.articleinfo.id,
          idx: item.idx
        },
        responseType: 'blob' // 重要：设置响应类型为blob
      }).then(res => {
        // 创建blob URL
        const blob = new Blob([res.data]);
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        // 从响应头获取文件名，如果没有则使用默认名称
        const contentDisposition = res.headers['content-disposition'];
        let filename = 'download';
        if (contentDisposition) {
          const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
          if (filenameMatch && filenameMatch[1]) {
            filename = filenameMatch[1].replace(/['"]/g, '');
            // 处理中文文件名编码
            if (filename.startsWith('UTF-8\'\'')) {
              filename = decodeURIComponent(filename.replace('UTF-8\'\'', ''));
            }
          }
        }
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        // 清理
        window.URL.revokeObjectURL(url);
        setTimeout(() => {
          document.body.removeChild(a);
        }, 100);
      }).catch(err => {
        console.error('下载失败:', err);
        this.$message({
          message: '下载失败，请稍后重试',
          type: 'error',
          duration: 2000
        });
      });
    },
    openfile(val) {
      console.log(val)
      return
      this.pdfurl = '';
      this.pdfname = val.name;
      if (!this.articleinfo.preview) {
        this.$message({
          message: '暂无预览权限！',
          type: 'warning'
        });
        return false
      }
      let data = {
        articleId: this.articleinfo.id,
        idx: val.idx
      }
      // this.loading = true;
      this.$http({
        url: "article/preview",
        method: "POST",
        data: this.$form(data)
      }).then(res => {
        // this.$crypto.decryptBackendData(res.data);
        // this.pdfurl = this.$crypto.decryptBackendData(res.data);
        // this.loading = false;
        // this.$refs.scrollContainer.scrollTop = 0;
      }).catch(err => {
        this.loading = false;
      });
    },
    replacePStylesEnhanced(htmlString) {
      // 创建临时 DOM 元素来解析 HTML
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = htmlString;

      // 获取所有的 p 元素
      // const pe0 = tempDiv.querySelectorAll('p:has(video)');
      const allParagraphs = this.$el.querySelectorAll('p');
      const pe0 = Array.from(allParagraphs).filter(p =>
          p.querySelector('video') !== null
      );
      const pe1 = tempDiv.querySelectorAll('p');
      const pe2 = tempDiv.querySelectorAll('ul');
      const pe3 = tempDiv.querySelectorAll('h1');
      const pe4 = tempDiv.querySelectorAll('h2');
      const pe5 = tempDiv.querySelectorAll('h3');
      const pe6 = tempDiv.querySelectorAll('h4');
      const pe7 = tempDiv.querySelectorAll('h5');
      const pe8 = tempDiv.querySelectorAll('span');
      const pe9 = tempDiv.querySelectorAll('div');
      const pe10 = tempDiv.querySelectorAll('ol');
      const pe11 = tempDiv.querySelectorAll('img');
      const pe12 = tempDiv.querySelectorAll('video');
      console.log('pe12', pe12)
      // 遍历每个 p 元素并修改样式
      pe0.forEach(p => {
        p.style.width = '100%';
      });
      pe1.forEach(p => {
        p.style.width = '100%';
        p.style.color = 'rgb(255, 255, 255)';
        p.style.backgroundColor = '';
      });
      pe2.forEach(p => {
        p.style.color = 'rgb(255, 255, 255)';
        p.style.backgroundColor = '';
      });
      pe3.forEach(p => {
        p.style.color = 'rgb(255, 255, 255)';
        p.style.backgroundColor = '';
      });
      pe4.forEach(p => {
        p.style.color = 'rgb(255, 255, 255)';
        p.style.backgroundColor = '';
      });
      pe5.forEach(p => {
        p.style.color = 'rgb(255, 255, 255)';
        p.style.backgroundColor = '';
      });
      pe6.forEach(p => {
        p.style.color = 'rgb(255, 255, 255)';
        p.style.backgroundColor = '';
      });
      pe7.forEach(p => {
        p.style.color = 'rgb(255, 255, 255)';
        p.style.backgroundColor = '';
      });
      pe8.forEach(p => {
        p.style.color = 'rgb(255, 255, 255)';
        p.style.backgroundColor = '';
      });
      pe9.forEach(p => {
        p.style.color = 'rgb(255, 255, 255)';
        p.style.backgroundColor = '';
      });
      pe10.forEach(p => {
        p.style.color = 'rgb(255, 255, 255)';
        p.style.backgroundColor = '';
      });
      pe11.forEach(p => {
        p.style.maxWidth = '100%';
      });
      pe12.forEach(video => {
        console.log('video',video,video.width,video.height);
        video.style.width = video.width+'px';
        video.style.height = video.height+'px';
        video.style.margin = 'auto';
        video.style.maxWidth = '100%';
      });
      // 设置所有视频自动循环播放
      Array.from(pe12).forEach(video => {
        // 设置视频属性
        video.loop = true;
        video.autoplay = true;
        video.muted = true; // 静音以提高自动播放成功率
        video.playsinline = true;
        video.controls = true; // 显示控制条，用户可以暂停/播放

        // 尝试自动播放（静音模式下通常会被允许）
        video.play().catch(error => {
          console.log('自动播放失败，用户需手动播放:', error);
          // 自动播放失败时，用户可以通过控制条手动播放
        });
      });
      // 返回修改后的 HTML 字符串
      return tempDiv.innerHTML;
    },

    newtodetail(val){
      this.$router.push({
        path: '/knowledge',
        query: {
          // 只保留非 'param1' 的查询参数
          ...this.$route.query,
          artiid: val.id, // 这里通过设置id刷新页面
          // id:this.dingid//搜索的时候传过了 这里传不传无所谓
        }
      }).then(() => {
        // 删除操作后的处理逻辑
      });
    },
    // ddd
    todetail(val) {
      let data = {
        articleId: val.id
      }
      this.pdflist = [];
      this.$http({
        url: "article/detail",
        method: "POST",
        data: this.$form(data)
      }).then(res => {
        if (res.data.content) {
          res.data.content = this.replacePStylesEnhanced(res.data.content);
        }
        this.articleinfo = res.data;
        console.log('this.articleinfo', this.articleinfo)
        this.detailnum = 2;
        this.$refs.scrollContainer.scrollTop = 0;
        if (res.data.attachmentList && res.data.preview) {
          res.data.attachmentList.forEach(item => {
            this.getfile(item);//获取文章详情
          })
        }
      });
    },
    getfile(val) {
      console.log(val)
      let data = {
        articleId: this.articleinfo.id,
        idx: val.idx
      }
      this.loading = true;
      this.$http({
        url: "article/preview",
        method: "POST",
        data: this.$form(data)
      }).then(res => {
        let pdfurl = this.$crypto.decryptBackendData(res.data);
        this.pdflist.push({name: val.name, url: pdfurl});
        console.log('this.pdflist', this.pdflist)
        this.loading = false;
      }).catch(err => {
        this.loading = false;
      });
    },
    changelei(val) {
      this.dingid = val.id;
      this.datalist = [];
      this.pageObj = {
        pageSize: 10,
        total: 0,
        currentPage: 1
      }
      this.getdata();
    },
    subbuopen() {
      this.detailnum = 3;
    },
    handleRowClick(row, column, event) {
      this.detailnum = 2;
      // 这里可以添加业务逻辑
    },
    nobu() {
      this.detailnum = 1;
    },
    subbu() {

    },
    // 富文本
    neiclick(val) {
      this.richText = val;
    },
    // 取消回复
    noreplay() {
      this.showMask = false;
    },
    // 分享
    subreplay() {
      if (this.checktreelist.length == 0) {
        this.$message({
          message: '请选择分享人！',
          type: 'warning'
        });
        return false
      }
      let data = {
        articleId: this.articleinfo.id,
        toUserId: this.checktreelist.map(item => item.id).toString(),
      }
      this.$http({
        url: "article/share",
        method: "POST",
        data: this.$form(data)
      }).then(res => {
        this.$message({
          message: '操作成功！',
          type: 'success'
        });
        this.showMask = false;
      });
    },
    // 回复
    replyx() {
      // this.replaylook = true;
      this.showMask = true;
    },
    fabu() {
      console.log('问你', this.content)
    },
    togglePicker() {
      this.showPicker = !this.showPicker;
    },
    togglePickerhui() {
      this.showPickerhui = !this.showPickerhui;
    },

    pageChange(page) {
      console.log('页码', page)
      this.pageObj.currentPage = page;
      this.$refs.scrollContainer.scrollTop = 0;
      this.getdata();
    },
  },

}
</script>
<style lang="scss">
.newwai-content {
  height: max-content;
}

//改个外层名字再用
.tanpassk {
  .el-dialog {
    border-radius: 16px;
  }

  .el-dialog__body {
    padding: 0px;
    background: #0B3E73;
    border-radius: 16px;
    overflow: hidden;
  }

  .el-dialog__header {
    display: none;
  }

}

.fenx1 {
  width: 60px;
  height: 24px;
  color: #9FE2FF;
  font-size: 14px;
  border: 1px solid #0090FF;
  background: rgba(0, 144, 255, 0.5);
  text-align: center;
  margin-left: 20px;
  border-radius: 4px;
  cursor: pointer;
  position: relative;
}

.tishi {
  border: 1px solid #3B5474;
  background: rgba(59, 84, 116, 0.5);
  color: white;
}

.tishi:hover::after {
  content: "暂无分享权限";
  position: absolute;
  left: 0;
  top: 27px;
  background: #333;
  width: 100px;
  color: white;
  padding: 5px;
  border-radius: 4px;
}

.fenx2 {
  width: 16px;
  height: 16px;
  margin-right: 2px;
}

.wlisti1 {
  width: 140px;
  max-height: 180px;
  border-radius: 2px;
  margin-right: 20px;
  img{
    width: 100%;
    height: auto;
    max-height: 180px;
  }
}

.fll1 {
  font-size: 18px;
  color: white;
}

.fll2 {
  margin-right: 20px;
  margin-left: 20px;
}

.fll3 {
  cursor: pointer;
}

.leihot {
  color: #0090FF;
}

.wxim1 {
  width: 18px;
  height: 13px;
  margin-right: 5px;
}

.wxim2 {
  width: 18px;
  height: 16px;
  margin-right: 5px;
}

.but1 {
  width: 10%;
  color: white;
  text-align: right;
  box-sizing: border-box;
  padding-right: 20px;
  font-size: 16px;
}

.but2 {
  width: 90% !important;
}

.but3 {
  width: 90%;
  border-radius: 8px;
  overflow: hidden;
}

.sta4 {
  width: 100%;
  box-sizing: border-box;
  min-height: 505px;
  padding: 40px 80px;
  border-radius: 16px;
  background: rgba(14, 62, 108, 0.5);
}

.sta5 {
  width: 100%;
  box-sizing: border-box;
  padding: 20px;
  border-radius: 16px;
  background: rgba(14, 62, 108, 0.5);
  color: white;
}

.colorql {
  color: #A0B8E2;
}

.sta6 {
  font-size: 16px;
  color: white;
  margin: 20px 0;
}


.overflow {
  width: 100%;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

</style>
<!--333-->
<style scoped lang="scss">

@media screen and (max-width: 1440px)  {
  .sformin .searbtn1{
    width: 50PX;
    height: 50PX;
    line-height: 50PX;
  }
  .sformin .searbtn2{
    width: 50PX;
    height: 50PX;
    line-height: 50PX;
  }
  /deep/ {
    .sformin .el-form-item__label{
      line-height: 50px !important;
    }
    .wnew200 .el-input__inner {
      width: 122px !important;
      height: 50px !important;
    }

    .wnew270 .el-input__inner {
      height: 50px !important;
      width: 250px !important;
    }
   .wnew270 .el-range-separator{
      line-height: 44px !important;
    }
  }
}
.stam1 {
  width: 1620px;
}

.outpage {
  height: calc(100vh - 80px);
  overflow: hidden;
}

.newkuanlo {
  width: max-content;
  max-width: 89%;
}

.w100 p {
  color: white !important;
}

.dingping {
  box-sizing: border-box;
  padding: 0px;
}

.wnew50 {
  width: 50% !important;
  box-sizing: border-box;
  padding: 20px !important;
}

.ifaout {
  box-sizing: border-box;
  position: relative;
  padding: 20px 20px;
  border-radius: 16px;
  margin-top: 20px;
  background: rgba(14, 62, 108, 0.9);
}

.pdf-name {
  font-size: 24px;
  color: white;
  font-weight: bold;
  margin-bottom: 10px;

  .pnammeov {
    width: 94%;
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.closepdf {
  position: absolute;
  right: 50px;
  top: 25px;
  cursor: pointer;
  z-index: 1000;
  width: 25px;
  height: 25px;
}

.clpdf {
  cursor: pointer;
  z-index: 1000;
  width: 25px;
  height: 25px;
}

.downimg {
  width: 16px;
  height: 16px;
  margin-left: 10px;
}

.butext {
  width: 78%;
  //background: pink;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.choosed6 {
  height: 90%;
  width: 100%;
  overflow-y: auto;
  box-sizing: border-box;
  padding-bottom: 20px;
}

.buimg {
  width: 16px;
  height: 16px;
  margin-right: 3px;
}

.quanx {
  color: white;
  font-size: 16px;
}

.choosep2 {
  color: white;
  margin-bottom: 10px;
}

.choosewai {
  height: 85%;
  margin-bottom: 1%;
  //background: cyan;
  //height: max-content;
  //max-height: 95%;
  overflow-y: auto;
}

.choosep1 {
  width: 187px;
  height: 54px;
  background: #1A5C9B;
  border: 1px solid #0090FF;
  border-radius: 5px;
  box-sizing: border-box;
  padding: 0 20px;
  margin-right: 15px;
  margin-bottom: 15px;
  float: left;

}

.choosep1:nth-child(4n) {
  margin-right: 0;
}

.choosed4 {
  width: 32px;
  height: 32px;
  border-radius: 50%;
}

.choosed5 {
  width: 20px;
  height: 20px;
  cursor: pointer;
}

.choosed3 {
  color: white;
  margin-left: 2px;
  margin-right: 2px;
  text-align: center;
}

.tanpassk .el-dialog .el-dialog__header {
  display: none !important;
  padding: 0 !important;
}

/deep/ {
  .custom-tree-node {
    width: 100%;
    //background: plum;
  }

  .choosed1 {
    .el-input__inner {
      border-radius: 20px;
      background: #02274C;
      border: 1px solid #02274C;
      color: white;
    }

    .el-checkbox__inner {
      width: 16px;
      height: 16px;
    }

    .el-checkbox__inner::after {
      height: 8px;
      left: 5px;
    }
  }

  .el-tree {
    background: transparent;
    color: white;
    font-size: 18px;
  }

  .el-tree-node__content {
    height: 35px;
    line-height: 35px;
    background-color: transparent !important;
  }

  /* 鼠标悬停时的背景色 */

  /* 当前选中节点的背景色 */
  .el-tree-node.is-current > .el-tree-node__content {
    background-color: transparent !important;
  }

  .el-tree-node__content:hover, .el-upload-list__item:hover {
    background: transparent;
  }

  .fenxd1 {
    height: 630px;
    //border-radius: 16px;
    background: #0E3E6C;
  }
}

.choosed1 {
  width: 25%;
  height: 100%;
  box-sizing: border-box;
  padding: 20px;
  border-radius: 16px 0 0 16px;
}

.choosed2 {
  width: 75%;
  height: 100%;
  box-sizing: border-box;
  padding: 20px;
  border-radius: 0 0 16px 16px;
  background: linear-gradient(0deg, #1A5C9B 0%, #093B6E 100%)
}

.sta9 {
  //width: 85%;
  color: #0090FF;
}

.sta8 {
  width: 26px;
  height: 30px;
  margin-right: 15px;
}

.sta7 {
  width: 100%;
  box-sizing: border-box;
  padding: 20px;
  background: rgba(10, 40, 70, 0.8);
  border-radius: 16px;
  margin-top: 15px;
}

.listz1 {
  box-sizing: border-box;
  padding: 20px 0;
  width: 88%;
  height: 100%;
}

.listz2 {
  color: #B2B4CB;
}

.noborder {
  border: none !important;
  padding: 0 !important;
  color: white !important;
  text-decoration: none;
  background-color: transparent !important;
  text-align: left !important;
  font-size: 24px !important;
  font-weight: bold;
}

.noborder:hover {
  background: none;
  color: #0090FF !important;
}

.titleborder {
  border: none !important;
  padding: 0 !important;
  color: white !important;
  text-decoration: none;
  background-color: transparent !important;
  text-align: center !important;
  font-size: 30px !important;
  font-weight: bold;
  margin-bottom: 10px;
}

.titleborder:hover {
  background: none;
  color: #fff !important;
}

/deep/ {
  .but2 .el-input__inner {
    background: #0E3E6C;
    border: none !important;
    color: white;
    height: 50px;
    line-height: 50px;
  }
}

.stamiddle {
  height: calc(100vh - 160px);
  min-height: calc(100vh - 160px);
  overflow-y: auto;
  background-image: url("../assets/img/kongbaibg.png");

  &::-webkit-scrollbar {
    display: inline-block !important;
    width: 2px;
    height: 2px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #05121D;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-track {
    background-color: #f2f2f2;
    border-radius: 10px;
  }
}

.forum2 {
  background: rgba(14, 62, 108, 0.8);
  box-sizing: border-box;
  border-radius: 16px;
  padding: 30px 40px 40px 40px;
  color: white;
  //min-height: 600px;
  min-height: 74vh;

  overflow: hidden;
  margin-bottom: 40px;

}


/* 关键：使用深度选择器修改表格标题样式 */
::v-deep .el-table__header {
  border-radius: 15px 15px 0 0;
  overflow: hidden;
}

::v-deep .el-table__body tr:hover > td > .cell > button {
  color: #0090FF !important;
}

::v-deep .el-table {
  border-radius: 16px 16px 0 0;
  overflow: hidden;
}

/* 标题单元格背景色和边框 */
::v-deep .el-table__header th {
  background-color: #0566B5 !important; /* 标题背景色 */
  color: white;
  border-bottom: none !important;
}

/* 表格整体圆角 */
::v-deep .el-table--border {
  border-radius: 16px;
  overflow: hidden;
  border: none !important;
}

::v-deep .el-table__body tr:hover > td {
  background-color: transparent !important; /* 覆盖默认悬停背景色 */
  color: #0090FF !important;
}

/* 核心：表格内容区域背景透明 */
/* 表格整体背景透明 */
::v-deep .el-table {
  background-color: transparent !important;
}

/* 表格内容行背景透明 */
::v-deep .el-table__body tr {
  background-color: transparent !important;
  color: white;
  cursor: pointer;
}

/* 表格单元格背景透明 */
::v-deep .el-table__body td {
  background-color: transparent !important;
  border-color: #516D9E !important;
}

/* 展开行背景透明（如需） */
::v-deep .el-table__expanded-cell {
  background-color: transparent !important;
}

::v-deep .el-table::before {
  display: none;
}

::v-deep .el-table--border::after, .el-table--group::after, .el-table::before {
  display: none;
}


/deep/ {
  .el-textarea__inner {
    background: #0A2846;
    border-color: #0694FC;
    color: white;
  }

  .el-textarea__inner:focus {
    border-color: #0694FC !important;
  }

  .el-textarea__inner:hover {
    border-color: #0694FC !important;
  }

  .sformin .el-form-item {
    margin-bottom: 10px;
  }

  .sformin .el-input__inner {
    height: 60px;
    background: rgba(6, 15, 30, 0.5);
    border-radius: 16px;
    font-size: 18px;
    border: solid 1px #0694FC;
    color: white;
  }

  .sformin .el-form-item__label {
    height: 60px;
    line-height: 60px;
    color: white;
    font-size: 18px;
  }

  .sformin .el-range-input {
    color: white;
    font-size: 18px;
    background: rgba(14, 62, 108, 0);
  }

  .sformin .el-range-separator {
    line-height: 54px;
    color: white;
  }
}

.mlogo1 {
  width: 80px;
  height: 80px;
}

.mlp1 {
  font-size: 33px;
}

.mlp2 {
  font-size: 11px;
  letter-spacing: 0 !important;
}

.searbtn1 {
  width: 60PX;
  height: 60PX;
  text-align: center;
  line-height: 60PX;
  display: inline-block;
  background: #0090FF;
  border-radius: 16px;
  font-size: 24px;
  color: white;
  margin-right: 10px;
}

.searbtn2 {
  width: 60PX;
  height: 60PX;
  text-align: center;
  line-height: 60PX;
  display: inline-block;
  background: #DCDFE6;
  border-radius: 16px;
}

</style>